import React from 'react';
import { Link } from 'react-router-dom';
import './css/Navigation.css';

const Navigation: React.FC = () => {
  return (
    <div className="container">
      <nav>
        <a href="/" className="logo">AzureArch</a>
        <ul>
          <li><a href="/#services">Services</a></li>
          <li><a href="/#projects">Projects</a></li>
          <li><a href="/#tech">Technology</a></li>
          <li><Link to="/assessment">Assessment</Link></li>
          <li><a href="/#contact">Contact</a></li>
          <li><Link to="/login">Login</Link></li>
        </ul>
      </nav>
    </div>
  );
};

export default Navigation;
